import queryString from 'query-string'
import {
  AutocompleteInput,
  Create,
  ReferenceInput,
  required,
  SaveButton,
  SimpleForm,
  Toolbar,
  useNotify,
  useRedirect,
} from 'react-admin'
import { useHistory } from 'react-router'
import { usePageTitle } from 'shared/components/PageTitle/PageTitle'

import { captureExceptionIfProduction, safeMatch } from 'helpers/utils'
import { applyReferralCode } from '../../api/core'
import { FullNameField } from '../Fields'

const ReferralCodeField = ({ record = {} }: any) => (
  <span>
    {record.human_id}, <FullNameField record={record.referrer} />
  </span>
)

const fullNameInput = (choice: any) => (choice ? `${choice.first_name} ${choice.last_name}` : '')
const refCodeInput = (choice: any) => (choice ? `${choice.human_id}, ${fullNameInput(choice.referrer)}` : '')

const refCodeMatchSuggestion = (filter: any, choice: any) => {
  if (!filter || !choice) {
    return null
  }
  const normalizedFilter = filter.trim().toLowerCase()
  const normalizedRefCode = choice.human_id.trim().toLowerCase()
  const normalizedFullName = fullNameInput(choice.referrer).trim().toLowerCase()
  return safeMatch(`${normalizedRefCode}${normalizedFullName}`, normalizedFilter)
}

const fullNameMatchSuggestion = (filter: any, choice: any) => {
  if (!filter || !choice) {
    return null
  }
  const normalizedFilter = filter.trim().toLowerCase()
  const normalizedFullName = fullNameInput(choice).trim().toLowerCase()
  return safeMatch(normalizedFullName, normalizedFilter)
}

const SaveButtonAltered = (props: any) => {
  const history = useHistory()
  const redirectTo = useRedirect()
  const notify = useNotify()
  const { basePath } = props

  const handleClick = (values: any, redirect: any) => {
    applyReferralCode(values.referree.id, values.referral_code)
      .then(() => {
        notify('Referral Code applied', { type: 'success' })
        if (props.returnUrl) return history.push(props.returnUrl)
        redirectTo(redirect, basePath)
      })
      .catch((error) => {
        notify(error.response.data[0], { type: 'error' })
        captureExceptionIfProduction(error)
      })
  }

  return <SaveButton {...props} onSave={handleClick} />
}

const ReferralCreateToolbar = (props: any) => (
  <Toolbar {...props}>
    <SaveButtonAltered
      label="Save"
      redirect="list"
      submitOnEnter={false}
      variant="text"
      returnUrl={props.returnUrl}
    />
  </Toolbar>
)

const ReferralCreate = (props: any) => {
  const params = queryString.parse(window.location.search)
  const returnUser = params.return_user
  const referree = params.referree
  const referrer = params.referrer
  usePageTitle('Create Referral')

  return (
    <Create {...props}>
      <SimpleForm
        toolbar={<ReferralCreateToolbar returnUrl={returnUser ? `/users/${returnUser}/show/` : null} />}
      >
        <ReferenceInput
          label="Referral Code (or Referrer)"
          source="referral_code"
          reference="referral-codes"
          validate={required()}
          filterToQuery={(searchText) => ({ search: searchText })}
          defaultValue={referrer}
          disabled={Boolean(referrer)}
        >
          <AutocompleteInput
            optionText={<ReferralCodeField />}
            inputText={refCodeInput}
            matchSuggestion={refCodeMatchSuggestion}
          />
        </ReferenceInput>
        <ReferenceInput
          label="Referree"
          source="referree.id"
          reference="users"
          filterToQuery={(searchText) => ({ search: searchText })}
          validate={required()}
          defaultValue={referree}
          disabled={Boolean(referree)}
        >
          <AutocompleteInput
            optionText={<FullNameField />}
            inputText={fullNameInput}
            matchSuggestion={fullNameMatchSuggestion}
          />
        </ReferenceInput>
      </SimpleForm>
    </Create>
  )
}

export default ReferralCreate
